export default __webpack_public_path__ + "static/media/study-small-blue.7b8fc97b.svg";